import { Tooltip, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

/**
 * Valor de uma linha "rótulo → valor" que pode não caber na largura disponível.
 *
 * Valores como o plano do contrato costumam ser uma única palavra longa
 * ("Clientes_Encantado_Inhare_Fibra250"), que não tem espaço onde quebrar e
 * escapa da linha. Trunca com reticências e mostra o texto completo em tooltip
 * apenas quando ele realmente não coube — tooltip em valor curto só atrapalha.
 *
 * IMPORTANTE: `noWrap` sozinho não trunca dentro de um flex container. Todo
 * flex item nasce com `min-width: auto`, que o impede de encolher abaixo do
 * conteúdo — por isso o `minWidth: 0` aqui, e por isso o Stack que envolve
 * este componente também precisa de `minWidth: 0`.
 */
const ValorTruncado = ({ children, sx }) => {
  const ref = useRef(null);
  const [truncado, setTruncado] = useState(false);
  const texto = children == null ? "" : String(children);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const medir = () => setTruncado(el.scrollWidth > el.clientWidth);
    medir();

    // A largura da barra lateral muda com a janela: o que cabia pode deixar de caber
    const observer = new ResizeObserver(medir);
    observer.observe(el);
    return () => observer.disconnect();
  }, [texto]);

  return (
    <Tooltip title={truncado ? texto : ""} placement="top">
      <Typography ref={ref} noWrap sx={{ minWidth: 0, ...sx }}>
        {children}
      </Typography>
    </Tooltip>
  );
};

export default ValorTruncado;
